<template>
    <div>
        <h2 class="mt-0">
            {{ $l10n.__('Unités') }}
        </h2>

        <h3>
            {{ $l10n.__('Paramétrage des unités') }}
        </h3>
        <p class="fs-3">
            {{
                $l10n.__(
                    'Ces unités sont proposées lors de la création d‘un produit ou d‘un service.',
                )
            }}
        </p>

        <div class="label-input">
            <span class="fs-3">{{ $l10n.__('Unité par défaut') }}</span>
            <el-select v-model="unit" class="inline">
                <el-option
                    v-for="unit in unitList"
                    :key="unit.id"
                    :label="unit.value"
                    :value="parseInt(unit.id)"
                >
                </el-option>
            </el-select>
            <CompassButton
                :label="$t.__('common.actions.edit')"
                type="tertiary"
                onclick="Prefs.editValuesList('units');"
            />
        </div>

        <div class="label-input">
            <span class="fs-3">{{ $l10n.__('Afficher l’unité dans la colonne') }}</span>
            <el-select v-model="unitColumn" class="inline">
                <el-option
                    v-for="column in unitColumnList"
                    :key="column.value"
                    :label="column.label"
                    :value="column.value"
                >
                </el-option>
            </el-select>
        </div>

        <h3>
            {{ $l10n.__('Paramétrage des unités de mesures') }}
        </h3>
        <p class="fs-3">
            {{
                $l10n.__(
                    'Ces unités de mesure serviront pour calculer les dimensions et caractéristiques de vos produits ainsi que pour calculer les poids des colis pour les livraisons.',
                )
            }}
        </p>

        <div class="label-input">
            <span class="fs-3">{{ $l10n.__('Unité de mesure') }}</span>
            <el-select v-model="dimensionUnit" class="inline">
                <el-option
                    v-for="unit in dimensionUnitList"
                    :key="unit.value"
                    :label="unit.label"
                    :value="unit.value"
                >
                </el-option>
            </el-select>
        </div>

        <div class="label-input">
            <span class="fs-3">{{ $l10n.__('Unité de poids') }}</span>
            <el-select v-model="weightUnit" class="inline">
                <el-option
                    v-for="unit in weightUnitList"
                    :key="unit.value"
                    :label="unit.label"
                    :value="unit.value"
                >
                </el-option>
            </el-select>
        </div>

        <h3>
            {{ $l10n.__('Précision de la colonne coût unitaire') }}
        </h3>

        <div class="label-input">
            <span class="fs-3">{{ $l10n.__('Précision de la colonne coût unitaire') }}</span>
            <el-select v-model="unitAmountPrecision" class="inline">
                <el-option
                    v-for="precision in unitAmountPrecisionList"
                    :key="precision"
                    :label="formatPrecision(precision)"
                    :value="precision"
                >
                </el-option>
            </el-select>
        </div>

        <div class="mt-3">
            <CompassButton :label="$t.__('common.actions.save')" @click.prevent="save" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        defaultUnit: {
            type: Number,
            required: true,
        },
        defaultUnitColumn: {
            type: String,
            required: true,
        },
        defaultDimensionUnit: {
            type: String,
            required: true,
        },
        defaultWeightUnit: {
            type: String,
            required: true,
        },
        defaultUnitAmountPrecision: {
            type: String,
            required: true,
        },
        unitList: {
            type: Object,
            required: true,
        },
        unitColumnList: {
            type: Object,
            required: true,
        },
        weightUnitList: {
            type: Object,
            required: true,
        },
        dimensionUnitList: {
            type: Object,
            required: true,
        },
        unitAmountPrecisionList: {
            type: Array,
            required: true,
        },
        prefsId: {
            type: Number,
            required: true,
        },
        canEditUnit: {
            type: Boolean,
            required: true,
        },
    },
    data: function () {
        return {
            unit: this.defaultUnit,
            unitColumn: this.defaultUnitColumn,
            weightUnit: this.defaultWeightUnit,
            dimensionUnit: this.defaultDimensionUnit,
            unitAmountPrecision: this.defaultUnitAmountPrecision,
        };
    },
    methods: {
        formatPrecision: function (value) {
            return value === 'default' ? this.$l10n.__('Valeur par défaut') : value;
        },
        save: function () {
            let options = {
                unit: this.unit,
                unitColumn: this.unitColumn,
                weightUnit: this.weightUnit,
                dimensionUnit: this.dimensionUnit,
                unitAmountPrecision: this.unitAmountPrecision,
            };

            this.$ajax.put(
                `/rest/unit/preferences/${this.prefsId}`,
                {},
                options,
                (data) => {
                    Push.success(this.$l10n.__('Préférences enregistrées'));
                },
                (error) => {
                    let errors = {};
                    const messages = error.response.data.error.message;
                    Object.keys(messages).forEach(function (key) {
                        Push.error(messages[key]);
                    });
                },
            );
        },
    },
};
</script>
